import { SITE_URL, SITE_NAME, ORG, LOGO_URL, absUrl } from "./siteConfig";

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: ORG.name,
  legalName: ORG.legalName,
  url: SITE_URL,
  logo: LOGO_URL,
  foundingDate: ORG.foundingDate,
  sameAs: ORG.sameAs,
  contactPoint: {
    "@type": "ContactPoint",
    telephone: ORG.telephone,
    email: ORG.email,
    contactType: "sales",
    areaServed: "IT",
    availableLanguage: ["Italian"],
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: ORG.streetAddress,
    postalCode: ORG.postalCode,
    addressLocality: ORG.addressLocality,
    addressRegion: ORG.addressRegion,
    addressCountry: ORG.addressCountry,
  },
  vatID: ORG.vatID,
});

export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#localbusiness`,
  name: ORG.name,
  image: `${SITE_URL}/og/og-default.jpg`,
  logo: LOGO_URL,
  url: SITE_URL,
  telephone: ORG.telephone,
  email: ORG.email,
  vatID: ORG.vatID,
  priceRange: "€€",
  address: {
    "@type": "PostalAddress",
    streetAddress: ORG.streetAddress,
    postalCode: ORG.postalCode,
    addressLocality: ORG.addressLocality,
    addressRegion: ORG.addressRegion,
    addressCountry: ORG.addressCountry,
  },
  geo: { "@type": "GeoCoordinates", latitude: ORG.geo.lat, longitude: ORG.geo.lng },
  hasMap: ORG.mapsLink,
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "08:30",
    closes: "18:00",
  },
  parentOrganization: { "@id": `${SITE_URL}/#organization` },
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: SITE_NAME,
  inLanguage: "it-IT",
  publisher: { "@id": `${SITE_URL}/#organization` },
});

export const breadcrumbSchema = (items = []) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: absUrl(it.path),
  })),
});

export const productSchema = ({ name, description, image, path, brand = "TORRI", category }) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name,
  description,
  image: image ? absUrl(image) : undefined,
  url: absUrl(path),
  sku: (path || "").split("/").pop(),
  category,
  brand: { "@type": "Brand", name: brand },
  manufacturer: { "@id": `${SITE_URL}/#organization` },
});

export const newsArticleSchema = ({ title, description, image, path, section }) => ({
  "@context": "https://schema.org",
  "@type": "NewsArticle",
  headline: title,
  description,
  image: image ? [absUrl(image)] : undefined,
  articleSection: section,
  mainEntityOfPage: { "@type": "WebPage", "@id": absUrl(path) },
  publisher: { "@id": `${SITE_URL}/#organization` },
  author: { "@id": `${SITE_URL}/#organization` },
});

export const faqPageSchema = (faqs = []) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});


// AggregateRating + Review dalle recensioni Google (place-reviews.json).
// Merge sul nodo Organization esistente tramite lo stesso @id.
export const reviewsSchema = (data) => {
  if (!data || !data.rating || !data.userRatingsTotal) return null;
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: ORG.name,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: Number(data.rating),
      reviewCount: Number(data.userRatingsTotal),
      bestRating: 5,
      worstRating: 1,
    },
    review: (data.reviews || []).slice(0, 5).map((r) => ({
      "@type": "Review",
      reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5, worstRating: 1 },
      author: { "@type": "Person", name: r.author || "Utente Google" },
      reviewBody: r.text || "",
    })),
  };
};
